import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";

// import { Home } from "./pages/Home";
// import { Platform } from "./pages/Platform";
// import { About } from "./pages/About";
// import { Solutions } from "./pages/Solutions";

const Home = lazy(() => import("./pages/Home"));
const Platform = lazy(() => import("./pages/Platform"));
const Solutions = lazy(() => import("./pages/Solutions"));
const About = lazy(() => import("./pages/About"));

function App() {
  return (
    <Router>
      <Suspense fallback={<div>.</div>}>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/about" element={<About />} />
          <Route path="/solutions" element={<Solutions />} />
        </Routes>
        <Footer />
      </Suspense>
    </Router>
  );
}

export default App;
